import mitt from 'mitt';
import { IMedia } from '../entities/upload_media_v3';

// 上传相关事件类型定义
export enum UPLOAD_EVENTS {
  // 文件进度更新
  PROGRESS = 'upload:progress',
  // 文件上传成功
  SUCCESS = 'upload:success',
  // 文件上传失败
  ERROR = 'upload:error',
  // 单个文件完成（成功或失败）
  COMPLETE = 'upload:complete',
  // 队列变化
  QUEUE_CHANGE = 'upload:queue_change',
  // 所有任务完成
  ALL_COMPLETE = 'upload:all_complete',
  // 开始上传
  START = 'upload:start',
  // 取消上传
  CANCEL = 'upload:cancel',
  // 重试上传
  RETRY = 'upload:retry',
  // 移除文件
  REMOVE = 'upload:remove',
  // 清空队列
  CLEAR_QUEUE = 'upload:clear_queue',
  // 清空已完成文件
  CLEAR_COMPLETED = 'upload:clear_completed',
}

// 事件数据类型定义
export interface UploadEventData extends Record<string, unknown> {
  [UPLOAD_EVENTS.PROGRESS]: { fileUid: string; progress: number };
  [UPLOAD_EVENTS.SUCCESS]: { fileUid: string; media: IMedia };
  [UPLOAD_EVENTS.ERROR]: { fileUid: string; error: string };
  [UPLOAD_EVENTS.COMPLETE]: { fileUid: string; media: IMedia };
  [UPLOAD_EVENTS.QUEUE_CHANGE]: { queue: unknown[] };
  [UPLOAD_EVENTS.ALL_COMPLETE]: { queue: unknown[] };
  [UPLOAD_EVENTS.START]: { fileUid: string };
  [UPLOAD_EVENTS.CANCEL]: { fileUid: string };
  [UPLOAD_EVENTS.RETRY]: { fileUid: string };
  [UPLOAD_EVENTS.REMOVE]: { fileUid: string };
  [UPLOAD_EVENTS.CLEAR_QUEUE]: undefined;
  [UPLOAD_EVENTS.CLEAR_COMPLETED]: undefined;
  [key: symbol]: unknown;
}

// 创建上传专用的事件发射器
export const uploadEmitter = mitt<UploadEventData>();

// 导出事件类型和发射器
export { uploadEmitter as emitter, UPLOAD_EVENTS as UploadEvents };

// 通用事件类型定义
export enum COMMON_EVENTS {
  REFRESH_APP_RECORD = 'refresh_app_record',
  /** 刷新所有分组的文件 */
  REFRESH_ALL_GROUP_FILE = 'refresh_all_group_file',
  /** 退出登录/切换账号前触发，供各模块清理本地 storage 等 */
  BEFORE_ACCOUNT_CHANGE = 'before_account_change',
}

export interface CommonEventData extends Record<string, unknown> {
  [COMMON_EVENTS.REFRESH_APP_RECORD]: undefined;
  [COMMON_EVENTS.REFRESH_ALL_GROUP_FILE]: undefined;
  [COMMON_EVENTS.BEFORE_ACCOUNT_CHANGE]: undefined;
  [key: symbol]: unknown;
}

/** 通用的事件发射器 用于页面局部通讯 */
export const commonEmitter = mitt<CommonEventData>();
